import { PlayCircleIcon } from '@heroicons/react/20/solid';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store/store';
import {
  setPlaylistDialogOpen,
  setActivePlaylist,
  setActivePlaylistTitle,
  setActivePlaylistDescription,
} from '../../store/map3UISlice';
import {
  getAllVideoFromCommentsAtInterval,
  getVideoFromObjectiveComments,
} from '../../data/getVideoFromComments';
import { fetchMilestoneMap, fetchObjectives } from '../../store/map3DataSlice';

interface PlaylistPlayButtonProps {
  makeListFrom: 'interval' | 'objective';
  milestoneMapUuid: string;
  objectiveUuid?: string;
  interval?: string;
}

export function PlaylistPlayButton({
  makeListFrom,
  milestoneMapUuid,
  objectiveUuid,
  interval,
}: PlaylistPlayButtonProps) {
  const dispatch = useDispatch<AppDispatch>();

  const handleClick = async () => {
    let videos;
    let title;
    let description = '';

    const milestoneMap = await dispatch(fetchMilestoneMap(milestoneMapUuid)).unwrap();

    if (makeListFrom === 'interval' && interval) {
      videos = await getAllVideoFromCommentsAtInterval(milestoneMapUuid, interval);
      const intervalDate = new Date(interval).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      });
      const intervalType =
        milestoneMap.interval === 'hours'
          ? 'Hour'
          : milestoneMap.interval === 'days'
            ? 'Day'
            : milestoneMap.interval === 'weeks'
              ? 'Week'
              : milestoneMap.interval === 'months'
                ? 'Month'
                : milestoneMap.interval === 'quarters'
                  ? 'Quarter'
                  : milestoneMap.interval === 'years'
                    ? 'Year'
                    : '';
      title = `Playlist: ${intervalType} Ending ${intervalDate}`;
    } else if (makeListFrom === 'objective' && objectiveUuid) {
      videos = await getVideoFromObjectiveComments(milestoneMapUuid, objectiveUuid, interval);
      const objectives = await dispatch(fetchObjectives([objectiveUuid])).unwrap();
      const objective = objectives[0];
      const objectiveText = objective?.text || '';
      title = `Playlist: ${objectiveText.substring(0, 50)}${
        objectiveText.length > 50 ? '...' : ''
      }`;
    } else {
      console.error('Invalid playlist parameters');
      return;
    }

    dispatch(setActivePlaylist(videos));
    dispatch(setActivePlaylistTitle(title));
    dispatch(setActivePlaylistDescription(description));
    dispatch(setPlaylistDialogOpen(true));
  };

  if (makeListFrom === 'objective' && !objectiveUuid) return null;
  if (makeListFrom === 'interval' && !interval) return null;

  return (
    <div className="cursor-pointer flex items-center justify-center" onClick={handleClick}>
      <PlayCircleIcon className="h-6 w-6" />
    </div>
  );
}
